<script>
export default {
  name: 'Spinner',
  props: {
    size: {
      type: Number,
      required: true
    }
  }
};
</script>

<template>
  <div
    :class="['spinner']"
    :style="{
      width: size + 'px',
      height: size + 'px',
      borderWidth: size / 6 + 'px'
    }"
    role="status"
  >
    <span class="sr-only">Loading...</span>
  </div>
</template>

<style scoped>
.spinner {
  display: block;
  border-radius: 9999px;
  border-style: solid;
  border-color: currentColor;
  border-right-color: transparent;
  align-self: baseline;
  position: relative;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.sr-only {
  position: absolute;
  margin: -1px;
  height: 1px;
  width: 1px;
  overflow: hidden;
  white-space: nowrap;
  border: 0;
  padding: 0;
  clip: rect(0, 0, 0, 0);
}
</style>
